// API base path can be overridden with VITE_API_TARGET environment variable
// For local development: VITE_API_TARGET=http://localhost:8080
const apiTarget = import.meta.env.VITE_API_TARGET || import.meta.env.VITE_API_BASE_URL || 'https://api.trinnvis.io';

export const BASE_PATH = apiTarget.replace(/\/+$/, '');
export const endYear = 2030;
